module.exports = __webpack_public_path__ + "static/media/st.28e590a3.svg";